import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useRef } from "react";
import "./index.css";
import AutocompleteArrow from "../AutocompleteDropdownArrow";

const EditableAutocompleteNonCategory = ({
  chosen,
  classStyle = "newreact__select__azilis",
  setValue,
  disabled = false,
  propertyName = "value",
  styleNo = 1,
  scrollLeft = 0,
  menu,
  edit,
  options,
  check,
}) => {
  const divRef = useRef();

  // Find matching option when chosen is a primitive value (number/string)
  const getMatchingOption = (chosenValue) => {
    if (chosenValue === null || chosenValue === undefined) return null;
    
    // If check is "noProperty" and chosen is a primitive, find matching option
    if (check === "noProperty" && (typeof chosenValue === "number" || typeof chosenValue === "string")) {
      return options.find(
        (option) =>
          option.value === chosenValue ||
          option.qty === chosenValue ||
          option.title === chosenValue ||
          option.name === chosenValue ||
          Number(option.value) === Number(chosenValue) ||
          Number(option.qty) === Number(chosenValue)
      ) || null;
    }
    
    return null;
  };

  const renderGroup = (params) => (
    <li key={params.key}>
      <div style={{ fontWeight: "600" }}>{params.group}</div>
      <ul style={{ width: "100%" }}>{params.children}</ul>
    </li>
  );

  // Get the value to pass to Autocomplete
  const autocompleteValue = check === "noProperty"
    ? (() => {
        // If chosen is a primitive (number/string), find matching option object
        const matchingOption = getMatchingOption(chosen);
        return matchingOption || (chosen || null);
      })()
    : (chosen?.[propertyName] || null);

  return (
    <>
      {!edit ? (
        check === "noProperty" ? (
          <h4>{chosen}</h4>
        ) : (
          <h4>{chosen ? chosen[propertyName] : ""}</h4>
        )
      ) : (
        <div className="w-100" ref={divRef}>
          <Autocomplete
            className={classStyle + " azilis__dropdown__style" + styleNo}
            classNamePrefix="select__prefix__azilis"
            onChange={(event, opt) => {
              setValue(opt);
            }}
            value={autocompleteValue}
            disabled={disabled}
            isSearchable
            filterOptions={(options, { inputValue }) => {
              if (!inputValue || typeof inputValue !== 'string') {
                return options;
              }
              const searchValue = inputValue.toLowerCase();
              return options.filter((option) => {
                if (!option) return false;
                if (option?.title && typeof option.title === 'string') {
                  return option.title.toLowerCase().includes(searchValue);
                } else if (option?.value && typeof option.value === 'string') {
                  return option.value.toLowerCase().includes(searchValue);
                } else if (option?.name && typeof option.name === 'string') {
                  return option.name.toLowerCase().includes(searchValue);
                }
                return false;
              });
            }}
            options={options}
            getOptionLabel={(option) => {
              if (typeof option === "string") {
                return option;
              }
              if (option && typeof option === "object") {
                return option.value || option.title || option.name || "";
              }
              return "";
            }}
            popupIcon={<AutocompleteArrow />}
            isOptionEqualToValue={(option, value) => {
              if (typeof value === "string") {
                return (
                  option.value === value ||
                  option.title === value ||
                  option.name === value
                );
              }
              // Handle numeric values - compare option.value with the numeric value
              if (typeof value === "number") {
                return (
                  option.value === value ||
                  option.qty === value ||
                  Number(option.value) === value ||
                  Number(option.qty) === value
                );
              }
              return option === value;
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                InputProps={{
                  ...params.InputProps,
                  sx: {
                    fontSize: "12px",
                  },
                }}
                InputLabelProps={{
                  sx: {
                    fontSize: "12px",
                  },
                }}
              />
            )}
            renderGroup={renderGroup}
            renderOption={(props, option, { selected }) => (
              <li {...props}>
                {option.value || option.title || option.name || ""}
              </li>
            )}
            componentsProps={{
              paper: {
                sx: {
                  width: 300,
                },
              },
              clearIndicator: {
                sx: {
                  color: "white",
                  right: "-5px",
                  top: "10%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  "& .MuiSvgIcon-root": {
                    fontSize: "12px",
                  },
                },
              },
            }}
            styles={{
              menu: (baseStyles, state) => ({
                ...baseStyles,
                left: divRef.current
                  ? divRef.current.offsetLeft - scrollLeft + "px"
                  : "unset",
              }),
            }}
            classes={{
              paper: "dropdown-bg-custom",
            }}
            sx={{
              "& .MuiAutocomplete-inputRoot": {
                paddingRight: "0",
              },
              "&.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root": {
                paddingRight: "0",
              },
              "&.MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon .MuiOutlinedInput-root":
                {
                  paddingRight: "5px",
                },
              "& .MuiAutocomplete-popupIndicator": {
                top: "5px",
              },
            }}
          />
        </div>
      )}
    </>
  );
};

export default EditableAutocompleteNonCategory;
